// color config
import {
  textTitleHeader,
  textDescHeader,
} from "../../config/constant/color/index";

const styles = {
  height100: {
    height: "100%",
  },
  floatLeft: {
    float: "left",
    height: "100%",
  },
  titleProgramWrapper: {
    fontSize: "22px",
    fontWeight: "500",
    textAlign: "left",
    color: textTitleHeader,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "100%",
  },
  titleProgram: {
    color: textTitleHeader,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  titleProgramSkelWrapper: {
    textAlign: "left",
    lineHeight: "normal",
  },
  titleProgramSkel: {
    minWidth: "200px",
  },
  pageNameStyle: {
    fontSize: "22px",
    fontWeight: "500",
    textAlign: "left",
    color: textTitleHeader,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  displayNone: {
    display: "none",
  },
  colRightWrapper: {
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
    lineHeight: "normal",
    marginRight: "20px",
  },
  colRightWrapperMobile: {
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
    lineHeight: "normal",
    // marginTop: "4px",
  },
  imageLearningPoint: {
    width: "28px",
    height: "28px",
  },
  learningPointSkelWrapper: {
    display: "flex",
    flexDirection: "column",
    alignContent: "flex-start",
    alignItems: "flex-start",
    margin: "0 8px",
  },
  learningPointSkelWrapperMobile: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    margin: "0 24px 0px 8px",
    lineHeight: "100%",
  },
  points: {
    fontSize: "16px",
    fontWeight: "500",
    color: textTitleHeader,
  },
  pointsMobile: {
    fontSize: "12px",
    fontWeight: "500",
    color: textTitleHeader,
  },
  textLearningPoints: {
    fontSize: "14px",
    color: textDescHeader,
  },
  textLearningPointsMobile: {
    fontSize: "10px",
    color: textDescHeader,
    textAlign: "left",
  },
  colDropdownMenu: {
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
    lineHeight: "normal",
    marginLeft: "20px",
  },
  nameWrapper: {
    display: "flex",
    flexDirection: "column",
    alignContent: "flex-start",
    alignItems: "flex-start",
    margin: "0 8px",
    textAlign: "left",
  },
  textName: {
    fontSize: "16px",
    fontWeight: "500",
    color: textTitleHeader,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "auto",
    maxWidth: "130px",
  },
  downOutlineStyle: {
    cursor: "pointer",
    color: textDescHeader,
    margin: "5px 5px 5px 0",
  },
  upOutlineStyle: {
    cursor: "pointer",
    color: textDescHeader,
    margin: "5px 5px 5px 0",
  },
  dropDownItem: {
    alignItems: "center",
    color: textDescHeader,
    height: 37,
  },
  fontSize14: {
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
  },
  styleDpd: {
    alignItems: "center",
    color: textDescHeader,
    height: 37,
  },

  // Header Mobile Version
  headerMobile: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    height: "100%",
  },
};

export default styles;
